import React, { useRef, useEffect } from 'react';
import { CircleArrowLeft, PhoneCall } from 'lucide-react';
import { ProjectType } from '../../interfaces';

interface InvestmentPlansProps {
  topInvestments: any;
  view: string;
  setView: (view: string) => void;
  selectedProjects: ProjectType[];
  selectedProductInfo: {
    summary?: string;
    highlights?: string[];
  };
  handleCardClick: (product: any) => void;
}

const InvestmentPlans: React.FC<InvestmentPlansProps> = ({
  topInvestments,
  view,
  setView,
  selectedProjects,
  selectedProductInfo,
  handleCardClick
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    containerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  }, [view]);

  if (topInvestments?.plans.length === 0) {
    return null;
  }

  return (
    <>
      {view === 'projects' && selectedProjects.length > 0 && (
        <div className="selected-projects onDesk">
          <CircleArrowLeft
            size={36}
            style={{
              color: 'rgba(218, 41, 90, 1)',
              cursor: 'pointer',
            }}
            onClick={() => setView('products')}
          />
        </div>
      )}

      <div className="installment" ref={containerRef}>
        {view === 'products' &&
          topInvestments?.plans?.map((d: any, i: any) => (
            <div
              className="installment-card"
              key={i}
              onClick={() => handleCardClick(d)}
            >
              <div className="align">
                <p style={{ fontWeight: '600' }}>Name:</p>
                <p>{d.name}</p>
              </div>
              <div className="align">
                <p style={{ fontWeight: '600' }}>Summary:</p>
                <p>{d.summary}</p>
              </div>
              <div className="list">
                <p style={{ fontWeight: '600' }}>Highlights:</p>
                <ul>
                  {d?.highlights?.map((a: any, l: any) => (
                    <li key={l}>{a}</li>
                  ))}
                </ul>
              </div>
              <div className="read-more">
                <p>Read More</p>
              </div>
            </div>
          ))}

        {/* Show Projects View */}
        {view === 'projects' && (
          <>
            {view === 'projects' && selectedProjects.length > 0 && (
              <div className="selected-projects onMob">
                <CircleArrowLeft
                  size={36}
                  style={{
                    color: 'rgba(218, 41, 90, 1)',
                    cursor: 'pointer',
                  }}
                  onClick={() => setView('products')}
                />
              </div>
            )}

            {selectedProjects.length > 0 &&
              selectedProjects.map((proj) => (
                <div
                  key={proj.id}
                  className="installment-card"
                  style={{ cursor: 'default' }}
                >
                  <p style={{ fontSize: '14px' }}>
                    <strong>Name:</strong> {proj.name}
                  </p>
                  <p style={{ fontSize: '14px' }}>
                    <strong>Type:</strong> {proj?.type}
                  </p>
                  {selectedProductInfo?.summary && (
                    <div className="align">
                      <p style={{ fontWeight: '600' }}>Summary:</p>
                      <p>{selectedProductInfo.summary}</p>
                    </div>
                  )}

                  {(selectedProductInfo?.highlights?.length ?? 0) > 0 && (
                    <div className="list">
                      <p style={{ fontWeight: '600' }}>Highlights:</p>
                      <ul>
                        {selectedProductInfo.highlights?.map((a, l) => (
                          <li key={l}>{a}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <div
                    className="align"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <PhoneCall
                      size={16}
                      style={{
                        color: 'rgba(218, 41, 90, 1)',
                      }}
                    />
                    <p style={{ margin: '0px', fontWeight: '600' }}>
                      051 111 555 555
                    </p>
                  </div>
                </div>
              ))}
          </>
        )}
      </div>
    </>
  );
};

export default InvestmentPlans;
